/* eslint-disable no-extra-boolean-cast */
import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { InternalUsersService } from './features/internal-users/services/internal-users/internal-users.service';
import { TokenData } from './interfaces';
import { trigger, transition, style, animate } from '@angular/animations';
import { RolesEnum } from './enums/ipb-roles.enum';
import { AuthService } from './core/services/auth/auth.service';
import { getBackEnv } from './utils/Utils';
import { FullStoryService } from './core/services/fullstory/fullstory.service';

const version = '1.0.35';
@Component({
	selector: 'ipb-genesis-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: [
		trigger('fade', [
			transition(':enter', [style({ opacity: 0 }), animate('1s', style({ opacity: 1 }))]),
			transition(':leave', [animate('1s', style({ opacity: 0 }))]),
		]),
	],
})
export class AppComponent implements OnInit {
	public onLoadingRoles = false;
	public animationState = false;
	public fadeInTime = 1000;
	public roles: RolesEnum[] = [];
	public lastRole: string[] = [];
	public elementDisplayTime = 5000;

	#fullstory = inject(FullStoryService);

	public constructor(
		public router: Router,
		private internalUserService: InternalUsersService,
		private authService: AuthService,
	) {
		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				if (event.url === '/' && this.roles.length > 0) {
					this.authService.redirectToHome();
				}
			}
		});
		const labelVersion = document.querySelector('#version-lbl') as HTMLLabelElement | null;
		const backEnv = getBackEnv();
		if (labelVersion) {
			labelVersion.style.visibility = backEnv === 'PROD' ? 'hidden' : 'visible';
			labelVersion.innerText = `[${backEnv}] v${version}`;
			if (backEnv === 'PROD') labelVersion.remove();
		}
	}

	public ngOnInit(): void {
		this.#fullstory.init();

		const tokenData = this.authService.getTokenData();

		if (window.location.href.includes('/login') || !tokenData) return;

		if (tokenData?.role) {
			const rolesArray = Array.isArray(tokenData.role) ? tokenData.role : [tokenData.role];
			this.authService.setRoles = rolesArray.map(
				(role) => role.replace('_RO', '') as RolesEnum,
			);
		} else {
			this.loadRolesPermission(tokenData);
		}
	}

	public loadRolesPermission(tokenData: TokenData) {
		this.onLoadingRoles = true;
		try {
			this.internalUserService.getRolesAsigned(tokenData.userId).subscribe(
				(response) => {
					this.roles = (response.data?.roles ?? []).map(
						(role) => role.replace('_RO', '') as RolesEnum,
					);
					this.authService.setRoles = this.roles;

					setTimeout(() => {
						if (window.location.pathname === '/') this.authService.redirectToHome();
					}, 200);
					//FIXME: White screen freezing on start
					this.whiteScreenPrevent();
				}
			);
		} catch (error) {
			this.redirectToLogin();
		}
	}

	public whiteScreenPrevent() {
		setTimeout(() => {
			if (
				!document.querySelector('#main-component') &&
				!window.location.href.includes('login')
			) {
				const search = location.search.substring(1);
				const params =
					window.location.search == ''
						? undefined
						: {
							queryParams: JSON.parse(
								'{"' +
									decodeURI(search)
										.replace(/"/g, '\\"')
										.replace(/&/g, '","')
										.replace(/=/g, '":"') +
									'"}',
							),
						};
				this.router.navigate([location.pathname], params);
			}
		}, 1500);
	}

	public redirectToLogin() {
		this.router.navigate(['/login']);
	}
}
